import React from 'react';
import IconCross from '../Icons/IconCross';
import './Content.scss';
import {
    Button, Rating
} from 'semantic-ui-react'

import { Link } from 'react-router-dom';


const ContentHeader = ({ movie  }) => (
  <div className="contentnf">
    <div className="contentnf__background">
      <div className="contentnf__background__shadow" />
      <div
        className="contentnf__background__image"
        style={{ 'background-image': `url(${movie.imageBg})` }}
      />
    </div>
    <div className="contentnf__area">
      <div className="contentnf__area__container">
        <div className="contentnf__title"><p>{movie.title}</p></div>
        <div className="contentnf__description">
          <p>{movie.desc}</p>
        

</div>
      </div>
      
    </div>
  </div>
);

export default ContentHeader;
